var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAssinaturaVitalicia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#00B9FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_520_23263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5 45C40.5717 45 39.6815 44.6313 39.0251 43.9749C38.3687 43.3185 38 42.4283 38 41.5C38 40.5717 38.3687 39.6815 39.0251 39.0251C39.6815 38.3687 40.5717 38 41.5 38C42.4283 38 43.3185 38.3687 43.9749 39.0251C44.6313 39.6815 45 40.5717 45 41.5C45 42.4283 44.6313 43.3185 43.9749 43.9749C43.3185 44.6313 42.4283 45 41.5 45ZM41.5 43C41.8978 43 42.2794 42.842 42.5607 42.5607C42.842 42.2794 43 41.8978 43 41.5C43 41.1022 42.842 40.7206 42.5607 40.4393C42.2794 40.158 41.8978 40 41.5 40C41.1022 40 40.7206 40.158 40.4393 40.4393C40.158 40.7206 40 41.1022 40 41.5C40 41.8978 40.158 42.2794 40.4393 42.5607C40.7206 42.842 41.1022 43 41.5 43ZM30.5 34C30.0404 34 29.5852 33.9095 29.1606 33.7336C28.736 33.5577 28.3501 33.2999 28.0251 32.9749C27.7001 32.6499 27.4423 32.264 27.2664 31.8394C27.0905 31.4148 27 30.9596 27 30.5C27 30.0404 27.0905 29.5852 27.2664 29.1606C27.4423 28.736 27.7001 28.3501 28.0251 28.0251C28.3501 27.7001 28.736 27.4423 29.1606 27.2664C29.5852 27.0905 30.0404 27 30.5 27C31.4283 27 32.3185 27.3687 32.9749 28.0251C33.6313 28.6815 34 29.5717 34 30.5C34 31.4283 33.6313 32.3185 32.9749 32.9749C32.3185 33.6313 31.4283 34 30.5 34ZM30.5 32C30.8978 32 31.2794 31.842 31.5607 31.5607C31.842 31.2794 32 30.8978 32 30.5C32 30.1022 31.842 29.7206 31.5607 29.4393C31.2794 29.158 30.8978 29 30.5 29C30.1022 29 29.7206 29.158 29.4393 29.4393C29.158 29.7206 29 30.1022 29 30.5C29 30.8978 29.158 31.2794 29.4393 31.5607C29.7206 31.842 30.1022 32 30.5 32ZM43.071 27.515L44.485 28.929L28.93 44.485L27.516 43.071L43.07 27.515H43.071Z",
    fill: "#0A121F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_520_23263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAssinaturaVitalicia);
export default __webpack_public_path__ + "static/media/ic-assinatura-vitalicia.a8687e25edebf06b9d17521df31b4495.svg";
export { ForwardRef as ReactComponent };